const Spells = () => {
  return (
    <>
      <h2>Spells</h2>
      <div style={{display: "flex", justifyContent: "center"}}>
        <h6>Under construction.</h6>
      </div>
    </>
  );
};

export default Spells;